import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { Utils } from '../../../utils/utils';
import { SearchBarService } from '../../../../services/utils/searchBar.service';
import { NgbActiveOffcanvas, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { OffcanvasHistoryService } from '../../../../services/offcanvas-history.service';

@Component({
    selector: 'app-select-offcanvas-component',
    templateUrl: './select-offcanvas.component.html',
    styleUrls: ['./select-offcanvas.component.scss'],
    standalone: false
})
export class SelectOffcanvasComponent {
  protected Utils = Utils;
  @Input() items: any;
  @Input() selectedItem?: any;
  @Input() type: 'language' | 'country' | 'region' | 'district' | 'order' = 'language';
  @Input() title: string = 'Choose Option';

  constructor(
    protected searchFlow: SearchBarService,
    protected activeOffcanvas: NgbActiveOffcanvas,
    public offcanvasService: NgbOffcanvas,
    private offCanvasHistoryService: OffcanvasHistoryService,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService
  ) { }

  ngAfterViewInit() {
    if (!this.items) {
      const defaultOptions = this.getDefaultItemsAndTitle(this.type);
      this.items = defaultOptions.items;
      this.title = defaultOptions.title;
    } else {
      this.title = this.title ?? '';
    }
    this.selectedItem = this.selectedItem ?? this.getDefaultSelected(this.type);

    this.cdr.detectChanges();
  }

  private getDefaultItemsAndTitle(type: string): { items: any[], title: string } {
    switch (type) {
      case 'country':
        return { items: this.searchFlow.allCountries, title: this.translateService.instant('Choose Country') };
      case 'region':
        return { items: this.searchFlow.allRegions, title: this.translateService.instant('Choose Region') };
      case 'district':
        return { items: this.searchFlow.allDistricts, title: this.translateService.instant('Choose District') };
      default:
        return { items: [], title: '' };
    }
  }

  private getDefaultSelected(type: string): any {
    switch (type) {
      case 'language':
        return 'wl';
      case 'order':
        return 'name-asc';
      default:
        return undefined;
    }
  }

  onSelect(item: any) {
    if (this.type === 'language') {
      this.selectedItem = item.code;
    } else if (this.type === 'order') {
      this.selectedItem = item.orderBy + '-' + item.direction;
    } else {
      this.selectedItem = item;
    }
    this.offCanvasHistoryService.dismiss({ item: item, type: this.type });
  }

  closeOffcanvas() {
    this.offCanvasHistoryService.dismiss();
  }


}
